import React from 'react'
import cn from 'classnames'
// import { isEmpty } from 'lodash'

import { SearchResultType } from '@monorepo/interfaces'
import { Image, LightBox } from '@monorepo/components/common'
// import getImagineUrl from '@monorepo/core/helpers/getImagineUrl'

import { BrandInfoModal, Link } from 'App/Components'
import { OffersList } from './OffersList'
import { OffersControl } from './OffersControl'
import placeHolderImage from 'App/Resources/images/placeholder-300x300.png'

import style from './style.module.scss'

type PropsType = {
  item: SearchResultType
}

export const ResultItem: React.FC<PropsType> = ({ item }) => {
  return (
    <div className="products-list__item">
      <div className="product-card align-items-stretch flex-column flex-xl-row pl-0">
        {/* <div className="product-card__actions-list">
          <button
            className="product-card__action product-card__action--quickview"
            type="button"
            aria-label="Quick view"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16}>
              <path
                d="M14,15h-4v-2h3v-3h2v4C15,14.6,14.6,15,14,15z M13,3h-3V1h4c0.6,0,1,0.4,1,1v4h-2V3z M6,3H3v3H1V2c0-0.6,0.4-1,1-1h4V3z
M3,13h3v2H2c-0.6,0-1-0.4-1-1v-4h2V13z"
              />
            </svg>
          </button>
          <button
            className="product-card__action product-card__action--wishlist"
            type="button"
            aria-label="Add to wish list"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16}>
              <path
                d="M13.9,8.4l-5.4,5.4c-0.3,0.3-0.7,0.3-1,0L2.1,8.4c-1.5-1.5-1.5-3.8,0-5.3C2.8,2.4,3.8,2,4.8,2s1.9,0.4,2.6,1.1L8,3.7
l0.6-0.6C9.3,2.4,10.3,2,11.3,2c1,0,1.9,0.4,2.6,1.1C15.4,4.6,15.4,6.9,13.9,8.4z"
              />
            </svg>
          </button>
          <button
            className="product-card__action product-card__action--compare"
            type="button"
            aria-label="Add to compare"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16}>
              <path d="M9,15H7c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v12C10,14.6,9.6,15,9,15z" />
              <path d="M1,9h2c0.6,0,1,0.4,1,1v4c0,0.6-0.4,1-1,1H1c-0.6,0-1-0.4-1-1v-4C0,9.4,0.4,9,1,9z" />
              <path d="M15,5h-2c-0.6,0-1,0.4-1,1v8c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1V6C16,5.4,15.6,5,15,5z" />
            </svg>
          </button>
        </div> */}
        <div
          className={cn(
            'd-flex flex-column w-100 sticky-top bg-white',
            style.goodInfo
          )}
        >
          <div className="d-flex">
            <div className="product-card__image p-1" style={{ width: 82 }}>
              {typeof item.good.images !== 'undefined' &&
              item.good.images.length > 0 &&
              typeof item.good.thumbs !== 'undefined' &&
              item.good.thumbs.length > 0 ? (
                <LightBox images={item.good.images}>
                  <Image
                    className="img-thumbnail"
                    src={item.good.thumbs[0]}
                    alt={item.good.name}
                  />
                </LightBox>
              ) : (
                <Image
                  className="img-thumbnail"
                  src={placeHolderImage}
                  alt={item.good.name}
                />
              )}
              <div className="status-badge status-badge--style--success product-card__fit status-badge--has-icon status-badge--has-text">
                <div className="status-badge__body">
                  <div className="status-badge__icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={13}
                      height={13}
                    >
                      <path d="M12,4.4L5.5,11L1,6.5l1.4-1.4l3.1,3.1L10.6,3L12,4.4z" />
                    </svg>
                  </div>
                  {/* <div className="status-badge__text">
                    Part Fit for 2011 Ford Focus S
                  </div>
                  <div
                    className="status-badge__tooltip"
                    tabIndex={0}
                    data-toggle="tooltip"
                    title="Part Fit for 2011 Ford Focus S"
                  /> */}
                </div>
              </div>
            </div>
            <div className="product-card__info border-left-0 border-top-0 mr-3 p-md-0 d-flex flex-column align-items-stretch">
              <div className="product-card__meta border-left-0 d-flex justify-content-between flex-sm-row flex-column align-items-start w-100">
                <div className="mb-2">
                  <span className="product-card__meta-title">Бренд:</span>{' '}
                  <BrandInfoModal
                    brand={{
                      ...item.good.brand,
                      priority: Number(item.good.brand.priority),
                    }} // convert BrandType to IBrand
                    className="text-reset text-left p-0"
                    style={{ fontSize: 13 }}
                  >
                    {item.good.brandName}
                  </BrandInfoModal>
                </div>
                <div className="mb-2">
                  <span className="product-card__meta-title">Артикул:</span>{' '}
                  <Link
                    className="font-weight-bold text-dark"
                    to={item.good.searchLink}
                  >
                    {item.good.number}
                  </Link>
                </div>
              </div>
              <div className="product-card__name border-left-0 border-top pt-2 px-0 d-none d-md-block">
                <Link
                  to={item.good.searchLink}
                  className="text-break font-weight-light"
                  style={{ fontSize: '90%' }}
                >
                  {item.good.description}
                </Link>
              </div>
            </div>
          </div>
          <div className="product-card__name border-0 mx-2 mb-2 d-md-none border-bottom font-italic">
            <Link
              to={item.good.searchLink}
              className="text-break font-weight-light"
              style={{ fontSize: '80%' }}
            >
              {item.good.description}
            </Link>
          </div>
        </div>
        <div
          className={cn(
            style.offersContainer,
            'product-card__footer',
            'd-flex',
            'flex-column',
            'justify-content-between',
            // 'border-left-0',
            // 'pl-0',
            'm-0'
            // 'w-100'
          )}
        >
          <OffersList items={item.offers} />
          <OffersControl item={item} />
        </div>
      </div>
    </div>
  )
}
